// Renders always-available page position and navigation controls.
import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatNumber } from "../../lib/format";
import { Button } from "../ui/button";

interface PaginationControlsProps {
  pageIndex: number;
  pageCount: number;
  onPrevious: () => void;
  onNext: () => void;
}

/** Keeps page context and directional navigation together in the primary toolbar row. */
export function PaginationControls({
  pageIndex,
  pageCount,
  onPrevious,
  onNext
}: PaginationControlsProps) {
  return (
    <div className="flex items-center gap-1.5" role="group" aria-label="Pagination">
      <span className="text-muted-foreground">
        {formatNumber(pageIndex + 1)}/{formatNumber(pageCount)}
      </span>
      <Button
        type="button"
        variant="outline"
        size="icon"
        aria-label="Previous page"
        disabled={pageIndex === 0}
        onClick={onPrevious}
      >
        <ChevronLeft className="h-3.5 w-3.5" aria-hidden="true" />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="icon"
        aria-label="Next page"
        disabled={pageIndex >= pageCount - 1}
        onClick={onNext}
      >
        <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />
      </Button>
    </div>
  );
}
